module.exports = __webpack_public_path__ + "static/img/view.7445aea.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/product/view.png
// module id = 34qI
// module chunks = 1